import './scss/index.scss';
import './js/index';
